export const CATEGORY_MENU_WIDTH = 236;
